import React from "react";
import "../../styles/PlacementNetworking.css";

const PlacementNetworking = () => {
  const placementData = [
    {
      id: 1,
      title: "Global Placement Support",
      desc: "Connect with recruitment agencies & multinational firms.",
      // Image: A professional handshake or diverse business team connecting
      img: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=600&q=80",
    },
    {
      id: 2,
      title: "Industry Networking Events",
      desc: "Build strong professional contacts worldwide.",
      // Image: A group of professionals talking/networking at an event
      img: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?auto=format&fit=crop&w=600&q=80",
    },
    {
      id: 3,
      title: "Career Counselling",
      desc: "Personalized guidance for global career paths.",
      // Image: A one-on-one mentorship or consulting session
      img: "https://images.unsplash.com/photo-1573497620053-ea5300f94f21?auto=format&fit=crop&w=600&q=80",
    },
  ];

  return (
    <section className="placement-section container">
      {/* Section Title */}
      <h2 className="placement-main-title text-center">
        Placement & Networking
      </h2>

      <div className="placement-grid">
        {placementData.map((item) => (
          <div key={item.id} className="placement-card">
            {/* Image Container with Overflow Hidden for Zoom Effect */}
            <div className="placement-img-box">
              <img src={item.img} alt={item.title} className="placement-img" />
            </div>

            {/* Content */}
            <div className="placement-content">
              <h5 className="placement-title">{item.title}</h5>
              <p className="placement-desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PlacementNetworking;
